import { REFERENCE_MODES, } from './types.js';
function deepFreeze(value) {
    if (typeof value === 'object' && value !== null && !Object.isFrozen(value)) {
        for (const child of Object.values(value))
            deepFreeze(child);
        Object.freeze(value);
    }
    return value;
}
/**
 * Declare a route. Returns a frozen, fully typed route object with `smoke` defaulted
 * (`read` for GET, `deny` otherwise), `requestKind` defaulted to `json` and `docIds` normalized
 * to `{owner, target}` arrays. `reference` is required: omitting it is a type error and throws
 * here, naming the route. Every other rule is checked by `assertRouteTable`.
 */
export function defineRoute(def) {
    const id = typeof def?.id === 'string' ? def.id : '<route without id>';
    if (!REFERENCE_MODES.includes(def.reference)) {
        throw new TypeError(`defineRoute ${id}: "reference" is required and must be one of ${REFERENCE_MODES.join(', ')}` +
            ` (got ${JSON.stringify(def.reference) ?? 'undefined'})`);
    }
    const { errors, docIds, examples, upload, smoke: declaredSmoke, requestKind: declaredKind, changeBatchFrom, ...rest } = def;
    const smoke = declaredSmoke ?? (def.method === 'GET' ? 'read' : 'deny');
    const requestKind = declaredKind ?? 'json';
    const route = {
        ...rest,
        requestKind,
        ...(upload === undefined ? {} : { upload: structuredClone(upload) }),
        smoke,
        docIds: { owner: [...(docIds?.owner ?? [])], target: [...(docIds?.target ?? [])] },
        ...(errors === undefined ? {} : { errors: structuredClone(errors) }),
        ...(changeBatchFrom === undefined ? {} : { changeBatchFrom: { ...changeBatchFrom } }),
        examples: structuredClone(examples),
    };
    deepFreeze(route.docIds);
    if (route.errors !== undefined)
        deepFreeze(route.errors);
    if (route.upload !== undefined)
        deepFreeze(route.upload);
    if (route.changeBatchFrom !== undefined)
        deepFreeze(route.changeBatchFrom);
    deepFreeze(route.examples);
    return Object.freeze(route);
}
//# sourceMappingURL=define-route.js.map